import Error404Guard from '@src/components/guard/Error404Guard';
import ArticlePreview from '@src/features/tenant/articles/ArticlePreview';
import TenantPreviewLayout from '@src/layouts/tenant/TenantPreviewLayout';

function ArticlePreviewForm() {
  return (
    <Error404Guard isTenant={true}>
      <TenantPreviewLayout>
        <ArticlePreview />
      </TenantPreviewLayout>
    </Error404Guard>
  );
}

export default ArticlePreviewForm;
